import moment from 'moment';
import WordpressService from '@gik/core/models/wordpress/WordpressService';
import WordpressServiceCategory from '@gik/core/models/wordpress/WordpressServiceCategory';
import WordpressServiceProductBundle from '@gik/core/models/wordpress/WordpressServiceProductBundle';

export const CALENDAR_SET_DATE = 'SET_DATE';
export const CALENDAR_SET_ADD_DATE = 'SET_ADD_DATE';
export const CALENDAR_SET_DATA = 'CALENDAR_SET_DATA';

export const CALENDAR_SET_STATE = 'CALENDAR_SET_STATE';

export const CALENDAR_SET_SERVICES = 'CALENDAR_SET_SERVICES';
export const CALENDAR_SET_SERVICE_CATEGORIES = 'CALENDAR_SET_SERVICE_CATEGORIES';
export const CALENDAR_SET_SERVICE_PRODUCT_BUNDLES = 'CALENDAR_SET_SERVICE_PRODUCT_BUNDLES';
export const CALENDAR_SET_EVENT_TYPES = 'CALENDAR_SET_EVENT_TYPES';

export const CALENDAR_SET_MUTATING = 'CALENDAR_SET_MUTATING';

export const CALENDAR_SET_FATAL_ERROR = 'CALENDAR_SET_FATAL_ERROR';

export interface FatalCalendarError {
  errorReferenceId: string;
  message: string;
  code: number;
}

export function setDate(date: moment.Moment) {
  return { type: CALENDAR_SET_DATE, date };
}

export function setAddDate(addDate: moment.Moment) {
  return { type: CALENDAR_SET_ADD_DATE, addDate };
}

export function setCalendarState(state: string) {
  return { type: CALENDAR_SET_STATE, state };
}

export function setServices(services: WordpressService[]) {
  return { type: CALENDAR_SET_SERVICES, services };
}

export function setServiceCategories(serviceCategories: WordpressServiceCategory[]) {
  return { type: CALENDAR_SET_SERVICE_CATEGORIES, serviceCategories };
}

export function setServiceProductBundles(serviceProductBundles: WordpressServiceProductBundle[]) {
  return { type: CALENDAR_SET_SERVICE_PRODUCT_BUNDLES, serviceProductBundles };
}

export function setCalendarEventTypes(eventTypes: any[]) {
  return { type: CALENDAR_SET_EVENT_TYPES, eventTypes };
}

export function setCalendarData(data: any) {
  /* FIXME: this seems to be redux form data? */
  return { type: CALENDAR_SET_DATA, data };
}

export function setCalendarMutating(mutating: boolean) {
  return { type: CALENDAR_SET_MUTATING, mutating };
}

export function setFatalCalendarError(error: FatalCalendarError) {
  return { type: CALENDAR_SET_FATAL_ERROR, error };
}
